import React from 'react'

function Contatti() {
  return (
    <div className="page">
      <div className="text-page">
        <h1>Contatti</h1>
        <p>Per informazioni: evento@paese.it</p>
        <p>Oppure visita la nostra pagina Facebook!</p>
      </div>
    </div>
  )
}

export default Contatti
